import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
    ChangeBranding: "[ChangeBranding] Action"
};

const initialState = {
};

export const reducer = persistReducer(
    { storage, key: "mpcon-branding", whitelist: Object.keys(initialState) },
    (state = initialState, action) => {
        switch (action.type) {
            case actionTypes.ChangeBranding: {
                return { ...state , ...action.payload };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    changeBranding: payload => ({ type: actionTypes.ChangeBranding, payload })
};

